import Radio from "backbone.radio";
import ModalFormLayout from "../../generic/form-layout";
import Buttons from "../../generic/button/collection";
import Body from "./form-body";
import buttons from "./form-buttons";
import environment from "../../../common/environment";

const channel = Radio.channel("global");

class FormBody extends ModalFormLayout {
  events() {
    return {
      submit: "_onSubmit",
    };
  }

  onBeforeRender() {
    // get current healthcheck model
    this.model = channel.request("healthcheck:config");

    // listen once for successful model sync and reload app
    this.listenToOnce(this.model, "sync", () => {
      document.location.assign(`${environment.getAppHost()}/`);
    });
  }

  onBeforeShow() {
    // attach form fields
    this.body.show(
      new Body({
        model: this.model,
      })
    );

    // attach form buttons
    this.buttons.show(
      new Buttons({
        buttons,
        meta: this.options,
      })
    );
  }

  _onSubmit(e) {
    e.preventDefault();

    // create defaults object to track unset checkboxes
    const defaults = {
      enabled: false,
    };

    // extract submitted form data
    const formData = _.defaults(Backbone.Syphon.serialize(this), defaults);

    // update the model
    this.model.set(formData);
  }
}

export { FormBody as default };
